import React from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
    useLocation
  } from "react-router-dom";
import LoginWrapper from 'sections/login/LoginWrapper';
import Login from 'sections/login/Login';
import Main from 'sections/Main';
import {NewPassword, ResetPassword} from 'sections/login/PasswordHandlers';
import api from 'controllers/raymanAPI';
import Singletons from 'controllers/Singletons';
import settings from 'controllers/settings';

const AuthenticationState = {
  Unauthenticated: 1,
  CheckingCredentials: 2,
  Authenticated: 3
}

Object.freeze(AuthenticationState);
function PrivateRoute({ children, authenticated, ...props }) {

  const renderFn = ({ location }) => {
    //console.log(location.pathname);
    const loginPath = "/login";// + (location.pathname !== "/" && location.pathname !== "/login" ? "?from="+encodeURIComponent(location.pathname) : "");
    switch(authenticated)
    {
      case AuthenticationState.Authenticated:
          return children;
      case AuthenticationState.CheckingCredentials:
        return "";
      default:
        return <Redirect to={{
          pathname: loginPath,
          state: { from: location }
        }} />;
    }
  };

  return <Route
      {...props}
      render={renderFn}
  />

    // switch(authenticated)
    // {
    //   case AuthenticationState.Authenticated:
    //       return <Route {...props}>{children}</Route>;
    //   case AuthenticationState.CheckingCredentials:
    //     return "";
    //   default:
    //     return <Redirect to="/login" />;
    // }
  }

function App()
{

    const [logged, setLogged] = React.useState(AuthenticationState.CheckingCredentials);
    // let location = useLocation();
    // const { from } = location.state || { from: { pathname: "/" } };

    async function initializeUser(user, token)
    {      
      Singletons.Initialize(user);
      sessionStorage.setItem("userToken", token);
      setLogged(AuthenticationState.Authenticated);
    }

    

    React.useEffect(function CheckToken() {

        let token = sessionStorage.getItem("userToken");
        if(token)
        {
          api.internalApi.token = token;
          api.users.getCurrent().then((response) =>
          {
            if(response.ok)
            {
              response.json().then((user) => {
                initializeUser(user, token);
              });
              
            }
            else
            {
              sessionStorage.removeItem("userToken");
              setLogged(AuthenticationState.Unauthenticated);
            }
          });
        }
        else
        {
          setLogged(AuthenticationState.Unauthenticated);
        }
    }, []);

    return <Router>
        <Switch>
            <Route path="/login">
                <LoginWrapper><Login onUserLogged={(loginResponse) => initializeUser(loginResponse.user, loginResponse.token)} /></LoginWrapper>
                {logged === AuthenticationState.Authenticated ? <Redirect to={"/"} /> : ""}
            </Route>
            <Route path="/new-password/:token">
                <LoginWrapper><NewPassword /></LoginWrapper>
            </Route>
            <Route path="/reset-password">
                <LoginWrapper><ResetPassword /></LoginWrapper>
            </Route>
            <PrivateRoute authenticated={logged} path="/"><Main /></PrivateRoute>
        </Switch>
    </Router>
}

export default App;
export {App};